import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../lib/cn.js';
export const Card = React.forwardRef(({ className, ...rest }, ref) => (_jsx("div", { ref: ref, className: cn('bg-secondary border border-border rounded-md p-6 shadow-sm', 'transition-[box-shadow,border-color] duration-base', 'hover:border-foreground/15 hover:shadow-md', className), ...rest })));
Card.displayName = 'Card';
//# sourceMappingURL=Card.js.map